export default "__VITE_ASSET__6e951a8d__"